const AppConfig = {
    appName: "Piranha Admin",
};

export default AppConfig;
